/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/await-thenable */
/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/require-await */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {API_BASE_URL} from 'config';
import type {
	ActivePoliciesDashboard,
	DataPlanTemplate,
	GxSession,
	IGetMetricsResponse,
	ISubscriberProfile,
	ReMapBD,
	ReMapDownload,
	SubscriptionData,
	CurrentDataPlan,
	SystemConfig,
	SystemConfigProperty,
	Operator,
	SignIn,
	SignInBody,
	Users,
	CreateUser,
	ResetPassword,
} from 'interfaces';
import type {DataServer} from 'pages/Dashboard/Cards';
import type {Policy} from 'types/general';
import {exportDataToCsv} from 'utils';

const LIMIT = Number(process.env.REACT_APP_PAGINATE_LIMIT || 10);

export const getTokenFromLocalStorage = () => {
	return localStorage.getItem('Token');
};

export const getRefreshTokenFromLocalStorage = () => {
	return localStorage.getItem('Refresh-Token');
};

const baseQuery = fetchBaseQuery({
	baseUrl: API_BASE_URL,
	// credentials: 'same-origin',
	prepareHeaders: async headers => {
		const token = await getTokenFromLocalStorage();
		const refreshToken = await getRefreshTokenFromLocalStorage();
		headers.set('Content-type', 'application/json');
		headers.set('Access-Control-Allow-Origin', '*');
		headers.set('pragma', 'no-cache');
		headers.set('cache-control', 'no-cache');

		if (token) {
			headers.set('Authorization', `Bearer ${token}`);
			if (refreshToken) {
				headers.set('Refresh-Token', `Bearer ${refreshToken}`);
			} else {
				headers.delete('Refresh-Token');
			}
		} else {
			headers.delete('Authorization');
			headers.delete('Refresh-Token');
		}

		return headers;
	},
	timeout: 15000, // timeout general api
});

const baseQueryWithValidation = async (
	args: any,
	api: any,
	extraOptions: any,
) => {
	const response: any = await baseQuery(args, api, extraOptions);
	if (
		response &&
		response.meta &&
		response.meta.response &&
		response.meta.response.headers &&
		response.meta.response.headers.get('Authorization')
	) {
		localStorage.setItem(
			'Token',
			response.meta.response.headers.get('Authorization'),
		);
		localStorage.setItem(
			'Refresh-Token',
			response.meta.response.headers.get('Refresh-Token'),
		);
	}
	return response;
};

export const apiSlice = createApi({
	reducerPath: 'api',
	baseQuery: baseQueryWithValidation,
	tagTypes: [
		'Policy',
		'PolicyCount',
		'Session',
		'SystemConfig',
		'SubscriberPlan',
		'ReMapBD',
		'ReMapSize',
		'SubscriptionData',
		'Operators',
		'Users',
		'UsersCount',
	],
	endpoints: builder => ({
		// !GET ENDPOINTS
		getCpuProcess: builder.query<IGetMetricsResponse, void>({
			query: () => '/actuator/metrics/process.cpu.usage',
		}),
		getCpuSystem: builder.query<IGetMetricsResponse, void>({
			query: () => '/actuator/metrics/system.cpu.usage',
		}),
		getMemoryMax: builder.query<IGetMetricsResponse, void>({
			query: () => '/actuator/metrics/jvm.memory.max',
		}),
		getMemoryUsed: builder.query<IGetMetricsResponse, void>({
			query: () => '/actuator/metrics/jvm.memory.used',
		}),
		getDiskFree: builder.query<IGetMetricsResponse, void>({
			query: () => '/actuator/metrics/disk.free',
		}),
		getDiskTotal: builder.query<IGetMetricsResponse, void>({
			query: () => '/actuator/metrics/disk.total',
		}),
		getAllPolicies: builder.query<Policy[], number>({
			query: (page: number) =>
				`/policy-engine-mgmt/v1/policy-sets?order=DESC&page=${page}&pageSize=${Number(
					LIMIT,
				)}`,
			serializeQueryArgs: ({endpointName}) => endpointName,
			// Refetch when the page arg changes
			forceRefetch({currentArg, previousArg}) {
				return currentArg !== previousArg;
			},
			transformResponse: (response: Policy[]) => {
				if (response.length && response?.[0].detail === 'Invalid page.') {
					return [];
				}
				return response;
			},
			providesTags: ['Policy'],
		}),
		getActivePolicy: builder.query<Policy, void>({
			query: () => ({
				url: '/policy-engine-mgmt/v1/policy-sets/active',
				providesTags: ['Policy'],
			}),
		}),
		getTestingPolicy: builder.query<Policy, void>({
			query: () => ({
				url: '/policy-engine-mgmt/v1/policy-sets/test',
				providesTags: ['Policy'],
			}),
		}),
		getPoliciesCount: builder.query<number, void>({
			query: () => '/policy-engine-mgmt/v1/policy-sets/size',
			providesTags: ['PolicyCount'],
		}),
		getPolicy: builder.query<string, Policy>({
			query: (data: Policy) => ({
				url: `/policy-engine-mgmt/v1/policy-set/${data.title}/${data.version}/text-content`,
				responseHandler: (response: Response) => response.text(),
			}),
		}),
		getDiameterApp: builder.query<string[] | any, void>({
			query: () => '/actuator/metrics/diameter.messages.app',
			transformResponse: (response: IGetMetricsResponse) =>
				response?.availableTags?.[0].values,
		}),
		getDiameterAppQS: builder.query<number, string>({
			query: (qs: string) =>
				`/actuator/metrics/diameter.messages.app?tag=op:${qs}`,
			transformResponse: (response: IGetMetricsResponse) =>
				response.measurements?.[0].value,
		}),
		// gx sessions
		getGxSupi: builder.query<GxSession, string>({
			query: supi => `/gx-session-mgmt/v1/gx-sessions?supi=${supi}`,
			providesTags: ['Session'],
		}),
		getGxSessionIpv4Address: builder.query<GxSession, string>({
			query: ipv4Address =>
				`/gx-session-mgmt/v1/gx-sessions?ipv4=${ipv4Address}`,
			providesTags: ['Session'],
		}),
		getGxSessionIpv6Address: builder.query<GxSession, string>({
			query: ipv6Address =>
				`/gx-session-mgmt/v1/gx-sessions?ipv6=${ipv6Address}`,
			providesTags: ['Session'],
			transformResponse: (response: any) =>
				response.status === 404 ? [] : response,
		}),
		getGxDnn: builder.query<GxSession, string>({
			query: dnn => `/gx-session-mgmt/v1/gx-sessions?dnn=${dnn}`,
			providesTags: ['Session'],
		}),
		getGxGpsi: builder.query<GxSession, string>({
			query: gpsi => `/gx-session-mgmt/v1/gx-sessions?gpsi=${gpsi}`,
			providesTags: ['Session'],
		}),
		getGxImei: builder.query<GxSession, string>({
			query: imei => `/gx-session-mgmt/v1/gx-sessions?imei=${imei}`,
			providesTags: ['Session'],
		}),
		// rx sessions
		getRxSessionIpv4Address: builder.query<GxSession, string>({
			query: ipv4Address =>
				`/rx-session-mgmt/v1/rx-sessions?ipv4=${ipv4Address}`,
			providesTags: ['Session'],
		}),
		getRxSessionIpv6Address: builder.query<GxSession, string>({
			query: ipv6Address =>
				`/rx-session-mgmt/v1/rx-sessions?ipv6=${ipv6Address}`,
			providesTags: ['Session'],
			transformResponse: (response: any) =>
				response.status === 404 ? [] : response,
		}),
		getRxSupi: builder.query<GxSession, string>({
			query: supi => `/rx-session-mgmt/v1/rx-sessions?supi=${supi}`,
			providesTags: ['Session'],
		}),
		getRxDnn: builder.query<GxSession, string>({
			query: dnn => `/rx-session-mgmt/v1/rx-sessions?dnn=${dnn}`,
			providesTags: ['Session'],
		}),
		getRxGpsi: builder.query<GxSession, string>({
			query: gpsi => `/rx-session-mgmt/v1/rx-sessions?gpsi=${gpsi}`,
			providesTags: ['Session'],
		}),
		getSystemConfig: builder.query<SystemConfig, undefined>({
			query: () =>
				'/system-mgmt/v1/system-config?namespace=%2Fcom%2Fonevox%2Fpcrf%2Fsystem.properties',
			providesTags: ['SystemConfig'],
		}),
		getConfigServer: builder.query<SystemConfig, number>({
			query: id => `/config/server?id=${id}`,
		}),
		getServers: builder.query<DataServer[], null | undefined>({
			query: () => '/getservers',
		}),
		getSubscriptionData: builder.query<ISubscriberProfile, string>({
			query: id => `/subscription-mgmt/v2/subscription-data/${id}`,
			providesTags: ['SubscriptionData'],
		}),

		getSubscriptionDataGpsi: builder.query<ISubscriberProfile, string>({
			query: id => `/subscription-mgmt/v2/subscription-data/gpsi/${id}`,
		}),

		getSubscriptionDataPlanTemplate: builder.query<DataPlanTemplate, string>({
			query: (like: string) =>
				`/plan-mgmt/v1/plan-data?name.like=${like}&page=0&pageSize=500`,
			providesTags: ['SubscriberPlan'],
		}),

		getAllPlans: builder.query<DataPlanTemplate[], string>({
			query: () => '/plan-mgmt/v1/plan-data?page=0&pageSize=500',
			transformResponse: (response: DataPlanTemplate[]) => {
				if (response.length && response?.[0].name === 'Invalid page.') {
					return [];
				}
				return response;
			},
			providesTags: ['SubscriberPlan'],
		}),

		getOperatorsDataPlanTemplate: builder.query<Operator, any>({
			query: () =>
				'/operator-mgmt/v1/operator-data/operators?page=0&pageSize=10000',
			providesTags: ['Operators'],
		}),

		getReMapSetsAll: builder.query<ReMapBD[], undefined>({
			query: () => '/remap-mgmt/v1/re-map-sets',
		}),
		getReMapSets: builder.query<ReMapBD[], number | string>({
			query: (page: number) =>
				`/remap-mgmt/v1/re-map-sets?page=${page}&pageSize=${Number(LIMIT)}`,
			transformResponse: (response: ReMapBD[]) => {
				if (response.length && response?.[0].detail === 'Invalid page.') {
					return [];
				}
				return response;
			},
			providesTags: ['ReMapBD'],
		}),
		getReMapSetsSize: builder.query<number, undefined>({
			query: () => '/remap-mgmt/v1/re-map-sets/size',
			providesTags: ['ReMapSize'],
		}),
		getReMapSetDownload: builder.query<number, string>({
			query: (name: string) => ({
				url: `/remap-mgmt/v1/re-map-set/${name}`,
				method: 'GET',
				responseHandler: async (response: ReMapDownload | any) =>
					exportDataToCsv(await response.blob(), name),
				cache: 'no-cache',
			}),
		}),
		getReMapSetView: builder.query<number, string>({
			query: (name: string) => ({
				url: `/remap-mgmt/v1/re-map-set/${name}`,
				method: 'GET',
				cache: 'no-cache',
			}),
		}),
		getSubscriptionPlanData: builder.query<ISubscriberProfile, string>({
			query: supi =>
				`/subscription-mgmt/v2/subscription-data/${supi}/plan-data`,
			transformResponse: (response: any) => {
				if (response?.status === 500) {
					return [];
				}
				return response;
			},
		}),
		getPlanData: builder.query<CurrentDataPlan, string>({
			query: supi =>
				`/subscription-mgmt/v2/subscription-data/${supi}/plan-data`,
		}),
		getSystemConfigProperty: builder.query<SystemConfigProperty, void>({
			query: () =>
				'/system-mgmt/v1/system-config-property?key=flag-policy-engine-data',
		}),
		getActivePoliciesDashboard: builder.query<ActivePoliciesDashboard, void>({
			query: () => '/policy-engine-mgmt/v1/policy-sets/active',
		}),
		getVersion: builder.query<string, void>({
			query: () => '/login-mgmt/v1/version',
		}),

		getUsers: builder.query<Users[], any>({
			query: ({like, page}: any) =>
				`/user-mgmt/v1/user-data?username.like=${like}&page=${page}&pageSize=${Number(
					LIMIT,
				)}`,
			transformResponse: (response: Users[]) => {
				if (response.length && response?.[0].detail === 'Invalid page.') {
					return [];
				}

				return response;
			},
			providesTags: ['Users', 'UsersCount'],
		}),
		getUsersCount: builder.query<Users[], any>({
			query: ({like, page}: any) =>
				`/user-mgmt/v1/user-data/count?username.like=${like}&page=${page}&pageSize=${Number(
					LIMIT,
				)}`,
			transformResponse: (response: Users[]) => {
				if (response.length && response?.[0].detail === 'Invalid page.') {
					return [];
				}
				return response;
			},
			providesTags: ['Users', 'UsersCount'],
		}),

		// !POST ENDPOINTS
		signin: builder.mutation<SignIn, SignInBody>({
			query: (data: SignInBody) => ({
				url: '/login-mgmt/v1/login',
				method: 'POST',
				body: JSON.stringify(data),
				headers: {
					'Content-type': 'application/json',
				},
			}),
		}),

		createUser: builder.mutation<CreateUser, CreateUser>({
			query: (data: CreateUser) => ({
				url: '/user-mgmt/v1/user-data',
				method: 'POST',
				body: JSON.stringify(data),
				headers: {
					'Content-type': 'application/json',
				},
			}),
		}),

		dataPlanTemplate: builder.mutation<DataPlanTemplate[], DataPlanTemplate>({
			query: (data: DataPlanTemplate) => ({
				url: '/plan-mgmt/v1/plan-data',
				method: 'POST',
				body: JSON.stringify(data),
				headers: {
					'Content-type': 'application/json',
				},
			}),
		}),
		dataOperatorTemplate: builder.mutation<Operator[], any>({
			query: (data: Operator) => ({
				url: '/operator-mgmt/v1/operator-data/operators',
				method: 'POST',
				body: JSON.stringify(data),
				headers: {
					'Content-type': 'application/json',
				},
			}),
		}),
		subscriptionData: builder.mutation<any, any>({
			query: (data: SubscriptionData) => ({
				url: '/subscription-mgmt/v2/subscription-data',
				method: 'POST',
				body: JSON.stringify(data),
				headers: {
					'Content-type': 'application/json',
				},
			}),
		}),
		planDataAsignation: builder.mutation<any, any>({
			query: (data: DataPlanTemplate) => ({
				url: `/subscription-mgmt/v2/subscription-data/${data.ueId}/plan-data`,
				method: 'POST',
				body: JSON.stringify(data),
				headers: {
					'Content-type': 'application/json',
				},
			}),
		}),

		// !PUT ENDPOINTS
		updatePolicyInactivated: builder.mutation({
			query: (data: Policy) => ({
				url: `/policy-engine-mgmt/v1/policy-set/inactivated/${data.title}/${data.version}`,
				method: 'PUT',
				body: {},
			}),
			invalidatesTags: ['Policy', 'PolicyCount'],
		}),
		updatePolicyActivate: builder.mutation({
			query: (data: Policy) => ({
				url: `/policy-engine-mgmt/v1/policy-set/${data.title}/${data.version}/activate`,
				method: 'PUT',
				body: {},
			}),
			invalidatesTags: ['Policy', 'PolicyCount'],
		}),
		updatePolicyTest: builder.mutation({
			query: (data: Policy) => ({
				url: `/policy-engine-mgmt/v1/policy-set/${data.title}/${data.version}/test`,
				method: 'PUT',
				body: {},
			}),
			invalidatesTags: ['Policy', 'PolicyCount'],
		}),
		updatePolicyUnsetTest: builder.mutation({
			query: (data: Policy) => ({
				url: `/policy-engine-mgmt/v1/policy-set/${data.title}/${data.version}/unset-test`,
				method: 'PUT',
				body: {},
			}),
			invalidatesTags: ['Policy', 'PolicyCount'],
		}),
		updateSystemConfig: builder.mutation({
			query: data => ({
				url: `/system-mgmt/v1/system-config-property?key=${data.key}&value=${data.value}`,
				method: 'PUT',
				body: {},
			}),
			invalidatesTags: ['SystemConfig'],
		}),
		updateDataPlanTemplate: builder.mutation({
			query: (data: DataPlanTemplate) => ({
				url: `/plan-mgmt/v1/plan-data/${data.name}`,
				method: 'PUT',
				body: data,
			}),
		}),
		updateDataOperatorTemplate: builder.mutation({
			query: (data: Operator) => ({
				url: `/operator-mgmt/v1/operator-data/operators/${data.id}`,
				method: 'PUT',
				body: data,
			}),
		}),
		updateSubscriptionData: builder.mutation({
			query: (data: SubscriptionData) => ({
				url: `/subscription-mgmt/v2/subscription-data/${data.subscriberId}`,
				method: 'PUT',
				body: data,
			}),
		}),
		updateSubscriptionSupiData: builder.mutation({
			query: (data: SubscriptionData) => ({
				url: `/subscription-mgmt/v2/subscription-data/${data.subscriberId}/supi`,
				method: 'PATCH',
				body: JSON.stringify({newSupi: data.supi}),
			}),
		}),
		updateSubscriptionGpsiData: builder.mutation({
			query: (data: SubscriptionData) => ({
				url: `/subscription-mgmt/v2/subscription-data/${data.subscriberId}/gpsi`,
				method: 'PATCH',
				body: JSON.stringify({newGpsi: data.gpsi}),
			}),
		}),
		updateUser: builder.mutation({
			query: (data: CreateUser) => ({
				url: `/user-mgmt/v1/user-data/${data.username}`,
				method: 'PUT',
				body: data,
			}),
		}),
		resetPassword: builder.mutation({
			query: (data: ResetPassword) => ({
				url: `/user-mgmt/v1/user-data/${data.username}/password`,
				method: 'PUT',
				body: JSON.stringify({newPassword: data.password}),
			}),
		}),
		resetUsageDataPlanInstance: builder.mutation({
			query: (data: {supi: string; limitId: string}) => ({
				url: `/subscription-mgmt/v2/subscription-data/${data.supi}/plan-data/${data.limitId}/reset`,
				method: 'PUT',
			}),
		}),

		updateConsumedQuota: builder.mutation({
			query: (data: {supi: string}) => ({
				url: `/subscription-mgmt/v2/subscription-data/${data.supi}/plan-data/consumed-quota`,
				method: 'PUT',
			}),
		}),

		// !DELETE ENDPOINTS
		deletePolicy: builder.mutation({
			query: (data: Policy) => ({
				url: `/policy-engine-mgmt/v1/policy-set/${data.title}/${data.version}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['Policy', 'PolicyCount'],
		}),
		terminateGxSessionById: builder.mutation({
			query: (sessionId: string) => ({
				url: `/gx-session-mgmt/v1/gx-session?sessionId=${sessionId}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['Session'],
		}),
		abortRxSessionById: builder.mutation({
			query: (sessionId: string) => ({
				url: `/rx-session-mgmt/v1/rx-session?sessionId=${sessionId}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['Session'],
		}),
		deleteDataPlanTemplate: builder.mutation({
			query: (name: string) => ({
				url: `/plan-mgmt/v1/plan-data/${name}`,
				method: 'DELETE',
			}),
		}),
		deleteDataPlanInstance: builder.mutation({
			query: (data: {supi: string; planInstanceId: string}) => ({
				url: `/subscription-mgmt/v2/subscription-data/${data.supi}/plan-data/${data.planInstanceId}`,
				method: 'DELETE',
			}),
		}),
		deleteDataOperatorTemplate: builder.mutation({
			query: (name: string) => ({
				url: `/operator-mgmt/v1/operator-data/operators/${name}`,
				method: 'DELETE',
			}),
		}),
		deleteReMap: builder.mutation({
			query: (name: string) => ({
				url: `/remap-mgmt/v1/re-map-set/${name}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['ReMapBD', 'ReMapSize'],
		}),
		deleteSubscriptionData: builder.mutation({
			query: (ueId: string) => ({
				url: `/subscription-mgmt/v2/subscription-data/${ueId}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['SubscriptionData'],
		}),
		deleteUser: builder.mutation({
			query: (username: string) => ({
				url: `/user-mgmt/v1/user-data/${username}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['Users', 'UsersCount'],
		}),
	}),
});

export const {
	useGetCpuProcessQuery,
	useGetCpuSystemQuery,
	useGetMemoryMaxQuery,
	useGetMemoryUsedQuery,
	useGetDiskFreeQuery,
	useGetDiskTotalQuery,
	useGetAllPoliciesQuery,
	useGetPoliciesCountQuery,
	useDeletePolicyMutation,
	useUpdatePolicyInactivatedMutation,
	useUpdatePolicyActivateMutation,
	useUpdatePolicyTestMutation,
	useUpdatePolicyUnsetTestMutation,
	useLazyGetPolicyQuery,
	useGetActivePolicyQuery,
	useGetTestingPolicyQuery,
	useGetDiameterAppQuery,
	useLazyGetDiameterAppQSQuery,
	useGetActivePoliciesDashboardQuery,
	// gx sessions
	useLazyGetGxSessionIpv4AddressQuery,
	useLazyGetGxSessionIpv6AddressQuery,
	useLazyGetGxSupiQuery,
	useLazyGetGxDnnQuery,
	useLazyGetGxGpsiQuery,
	useLazyGetGxImeiQuery,
	useTerminateGxSessionByIdMutation,
	// rx sessions
	useLazyGetRxSessionIpv4AddressQuery,
	useLazyGetRxSessionIpv6AddressQuery,
	useLazyGetRxSupiQuery,
	useLazyGetRxDnnQuery,
	useLazyGetRxGpsiQuery,
	useAbortRxSessionByIdMutation,
	// system config
	useGetSystemConfigQuery,
	useUpdateSystemConfigMutation,
	useLazyGetConfigServerQuery,
	useLazyGetServersQuery,
	useGetSystemConfigPropertyQuery,
	// Subscriber profile
	useLazyGetSubscriptionDataQuery,
	useLazyGetSubscriptionDataGpsiQuery,
	useDataPlanTemplateMutation,
	useLazyGetSubscriptionDataPlanTemplateQuery,
	useLazyGetAllPlansQuery,
	useLazyGetOperatorsDataPlanTemplateQuery,
	useDeleteDataPlanTemplateMutation,
	useDeleteDataPlanInstanceMutation,
	useDeleteDataOperatorTemplateMutation,
	useUpdateDataPlanTemplateMutation,
	useSubscriptionDataMutation,
	usePlanDataAsignationMutation,
	useUpdateSubscriptionDataMutation,
	useUpdateSubscriptionSupiDataMutation,
	useUpdateSubscriptionGpsiDataMutation,
	useDeleteSubscriptionDataMutation,
	useLazyGetPlanDataQuery,
	useDataOperatorTemplateMutation,
	useUpdateDataOperatorTemplateMutation,
	useResetUsageDataPlanInstanceMutation,
	useUpdateConsumedQuotaMutation,
	// ReMap
	useGetReMapSetsAllQuery,
	useGetReMapSetsQuery,
	useGetReMapSetsSizeQuery,
	useDeleteReMapMutation,
	useLazyGetReMapSetDownloadQuery,
	useLazyGetReMapSetViewQuery,
	// version
	useGetVersionQuery,
	// signin
	useSigninMutation,
	// users
	useLazyGetUsersQuery,
	useGetUsersCountQuery,
	useCreateUserMutation,
	useDeleteUserMutation,
	useUpdateUserMutation,
	useResetPasswordMutation,
} = apiSlice;
